// extracted by mini-css-extract-plugin
export var cell = "_5b-4";
export var headerCell = "_5b-2";
export var rowHeader = "_5b-3";
export var table = "_5b-1";
export var tableContainer = "_5b-0";